import React, { useState, useContext, useEffect } from 'react'; 

import UserContext  from '../../context/Globales/UserContext';
import PropTypes from 'prop-types'
import clsx from 'clsx';

import {v4 as uuid } from 'uuid';
import PerfectScrollbar from 'react-perfect-scrollbar';

import {
    Box,
   
    Card,
  
    Divider, 
    Table,
    TableContainer,
    TableBody,
    TableCell,

    TableRow,
   
    makeStyles,
   
    TableHead,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {},
    actions: {
      justifyContent: 'flex-end'
    },
    FondoTable :{
        backgroundColor: theme.palette.greyFondo.main
    },
    containerTable: {
        maxHeight: 440,
        maxWidth: '100%'
      },
  }));

const TblDetalleConsultasRut =()=>{
    const classes = useStyles();
    const {  datoIC } = useContext(UserContext);
 

    
    return(
        <Card>
            

          
             
             
                <Divider />
            <PerfectScrollbar>
                <TableContainer className={classes.containerTable} >
                <Box >
                    <Table size="small" >
                        <TableHead className={classes.FondoTable}>
                            <TableRow>
                                <TableCell>Fecha detalle </TableCell>
                                <TableCell>Empresa</TableCell>
                               
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {datoIC && datoIC.DetallesConsultasRut?.DetalleConsultas.map((d)=>(
                                <TableRow  key={uuid()}>
                                    <TableCell>{d.FechaConsulta}</TableCell>
                                    <TableCell>{d.Empresa}</TableCell>
                                    
                                    
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Box>
                </TableContainer>
            </PerfectScrollbar>
         
            </Card>

    );

};

export default TblDetalleConsultasRut;